import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { Component } from "react";
import Home from './Home';
import AppTheme from "../src/shared-theme/AppTheme.js";
import 'maplibre-gl/dist/maplibre-gl.css';
import SignIn from './SignIn.js';
import Internal from './Internal.js';

import { CssBaseline } from "@mui/material";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "../src/theme/customizations";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};


export default class App extends Component {
  render() {
    return (
    <AppTheme {...this.props} disableCustomTheme={false} themeComponents={xThemeComponents}>
          <CssBaseline />
    <Router>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/NZ2026" element={<Home />}/>
        <Route path="/Internal" element={<Internal />}/>
        {/* <Route path="/pol" element={<MainPage />} />
        <Route path="/environ" element={<MainPage />} />
        <Route path="/healthcare" element={<MainPage />} />
        <Route path="/consumer" element={<MainPage />} /> */}
      </Routes>
    </Router>
    </AppTheme>
    );
  }
}

